import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromActive from '../reducers/active-storefront.reducer';

export const getActiveStorefrontState = createSelector(
  fromFeature.getStorefrontsState,
  (state: fromFeature.StorefrontsState) => state.active
);

export const getActiveStorefront = createSelector(getActiveStorefrontState, fromActive.getActiveStorefront);
export const getActiveStorefrontLoaded = createSelector(getActiveStorefrontState, fromActive.getActiveStorefrontLoaded);
export const getActiveStorefrontLoading = createSelector(getActiveStorefrontState, fromActive.getActiveStorefrontLoading);
export const getActiveStorefrontError = createSelector(getActiveStorefrontState, fromActive.getActiveStorefrontError);
